import React from "react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/content";
const questions = ["What has been confirmed?", "What remains a hypothesis?", "Which information is missing?", "What question should the next diagnostic check answer?", "And how will the result be documented?"];
export function AuthorLetter() {
  return <section className="w-full bg-navy px-5 py-16 sm:py-20" data-id="element-18" data-mp="1llu2w0n1oi5r">
      <div className="mx-auto grid max-w-5xl items-start gap-10 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]" data-id="element-19" data-mp="29adasf26msxb">
        <div className="md:sticky md:top-8" data-id="element-20" data-mp="2e73rn4lt9sjs">
          <img src={images.author} alt="Jason Mitchell, Automotive Electronics Specialist, in his workshop" className="w-full rounded-3xl object-cover" data-id="element-21" data-mp="1zjilf1tn3d7n" />
          <p className="mt-4 text-center font-display text-xl font-black text-white" data-id="element-22" data-mp="2s86e3igpx4v8">Jason Mitchell</p>
          <p className="text-center text-sm text-white/70" data-id="element-23" data-mp="2wymqcz8sykg0">Automotive Electronics Specialist</p>
        </div>

        <div data-id="element-24" data-mp="b0ofudabv2zy">
          <p className="text-sm font-extrabold uppercase tracking-wider text-gold" data-id="element-25" data-mp="b0ereu4xl3wd">A Message from Jason Mitchell</p>
          <h2 className="mt-3 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-white sm:text-4xl" data-id="element-26" data-mp="63fuk3tvuiuh">
            Why I Created the BCM Diagnostic Blueprint™
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-white/80" data-id="element-27" data-mp="fz9foblo3knv">
            <p data-id="element-28" data-mp="tqweoj6zv7ac">
              After spending time studying the challenges involved in automotive electronic diagnosis, one issue kept
              standing out to me.
            </p>
            <p data-id="element-29" data-mp="13plkvepj33ar">
              Technicians can have diagnostic scanners, wiring diagrams, technical information, and years of
              experience—and still struggle to organize a complicated investigation.
            </p>
            <p data-id="element-30" data-mp="35i9tk3kxyixx">
              It's tempting to jump straight to a suspected component. But a symptom isn't proof of a cause. A fault
              code doesn't automatically establish that a module has failed. And replacing a component without
              sufficient evidence can create unnecessary costs without resolving the original problem.
            </p>
            <p data-id="element-31" data-mp="31l4f09p4i4c">One of the most useful things a technician can have is a repeatable process:</p>
            <ul className="space-y-2 border-l-4 border-gold pl-5 font-semibold text-white" data-id="element-32" data-mp="80o9gkpoeocb">
              {questions.map(q => <li key={q} data-id="element-33" data-mp="d0ke8m676jsx">{q}</li>)}
            </ul>
            <p data-id="element-34" data-mp="h1cn3eb5qmoo">
              Not another enormous technical textbook. Not a promise that one flowchart can solve every BCM fault. And
              certainly not a replacement for proper training or manufacturer-specific service information.
            </p>
            <p data-id="element-35" data-mp="qqnw70y1nrck">
              My goal is to give you a clearer structure for organizing your diagnostic work, so you can focus your
              technical knowledge on the case in front of you. I hope it becomes a useful part of your diagnostic
              workflow.
            </p>
            <p className="font-display text-xl font-black italic text-white" data-id="element-36" data-mp="2l85qrb6pr1yq">— Jason Mitchell</p>
          </div>
        </div>
      </div>
      <div className="mt-12" data-id="element-37" data-mp="2gadwiailj3rd">
        <CtaButton tone="dark" data-id="element-38" data-mp="2b8olguvdiq3a">Start with the BCM Diagnostic Blueprint</CtaButton>
      </div>
    </section>;
}